<a
  *ngIf="status"
  [href]="msg?.content.URL"
  target="_blank"
  [ngClass]="{ 'no-link': !msg?.content.URL }"
>
  <div class="mifid-check">
    <div class="mifid-check__label">Trade Check</div>
    <div class="mifid-check__status">
      @switch (status) {
        @case ('ChecksInProgress') {
          <img
            class="mifid-check__status__icon"
            src="assets/shield-ellipsis.svg"
          />

          <span class="mifid-check__status__text">
            Pre trade checks in progress…
          </span>
        }

        @case ('GoodToTrade') {
          <img
            class="mifid-check__status__icon"
            src="assets/shield-check.svg"
          />

          <div class="mifid-check__status__text">
            <span
              class="mifid-check__status__text__title mifid-check__status__text__title--good-to-trade"
            >
              Good to trade
            </span>
            <div class="mifid-check__status__text__info">
              Compliance check passed
              <img
                *ngIf="msg?.content.URL"
                class="mifid-check__status__icon mifid-check__status__icon--link"
                src="assets/link.svg"
              />
            </div>
          </div>
        }

        @case ('ChecksFailed') {
          <img class="mifid-check__status__icon" src="assets/shield-x.svg" />

          <div class="mifid-check__status__text">
            <span
              class="mifid-check__status__text__title mifid-check__status__text__title--checks-failed"
            >
              Blocking pre-trade checks
            </span>
            <div class="mifid-check__status__text__info">
              Compliance check failed
              <img
                *ngIf="msg?.content.URL"
                class="mifid-check__status__icon mifid-check__status__icon--link"
                src="assets/link.svg"
              />
            </div>
          </div>
        }
      }
    </div>
  </div>
</a>
